import { render, staticRenderFns } from "./CallHistoryList.vue?vue&type=template&id=7c2b5f40&"
import script from "./CallHistoryList.vue?vue&type=script&lang=js&"
export * from "./CallHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports